<template>
  <div id="register-summary" class="kp-flat-card dark h-100 overflow-hidden">
    <h5 class="mb-20">Solution Configuration</h5>

    <div class="total-config d-flex mb-20" v-if="totalAmount">
      <strong class="flex-grow-1">Total</strong>
      <span class="text-right">
        <animated-number :value="totalAmount" :formatValue="formatToPrice" :duration="300" />
      </span>
    </div>

    <div class="selected-payment-acceptance mb-20" v-if="paymentsSelected.length">
      <h6>Payment Acceptance</h6>
      <ul>
        <li v-for="(payment, index) in paymentsSelected" :key="index" class="d-flex">
          <span class="flex-grow-1">{{ payment.name }}</span>
          <span class="pl-5 pr-5 text-right">{{ payment.price }}€</span>
          <span class="pl-5 text-right">{{ payment.percentage }}%</span>
        </li>
      </ul>
    </div>

    <div class="selected-service mb-20" v-if="servicesSelected.length">
      <h6>Services</h6>
      <ul>
        <li v-for="(service, index) in servicesSelected" :key="index" class="d-flex">
          <span class="flex-grow-1">{{ service.name }}</span>
          <span class="pl-5 pr-5 text-right">{{ service.price }}€</span>
          <span class="pl-5 text-right">{{ service.percentage }}%</span>
        </li>
      </ul>
    </div>

    <!-- <div class="selected-banking mb-20" v-if="bankingSelected.length">
      <h6>Banking</h6>
      <ul>
        <li v-for="(bank, index) in bankingSelected" :key="index" class="d-flex">
          <span class="flex-grow-1">{{ bank.name }}</span>
          <span class="pl-5 pr-5 text-right">{{ bank.price }}€</span>
          <span class="pl-5 text-right">{{ bank.percentage }}%</span>
        </li>
      </ul>
    </div>

    <div class="selected-apps mb-20" v-if="appsSelected.length">
      <h6>Apps</h6>
      <ul>
        <li v-for="(app, index) in appsSelected" :key="index" class="d-flex">
          <span class="flex-grow-1">{{ app.name }}</span>
          <span class="pl-5 pr-5 text-right">{{ app.price }}€</span>
          <span class="pl-5 text-right">{{ app.percentage }}%</span>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'register-summary',
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapFields({
      paymentAcceptance: 'paymentAcceptance',
      services: 'services'
    }),
    paymentsSelected() {
      return this.paymentAcceptance.filter(el => el.selected)
    },
    servicesSelected() {
      return this.services.filter(el => el.selected)
    },
    totalAmount() {
      let total = 0
      const merged = [].concat(this.paymentAcceptance, this.services)
      merged.forEach((el) => {
        if (el.selected) {
          total += el.price
        }
      })
      return total
    }
  },
  methods: {
    formatToPrice(value) {
      return `€ ${value.toFixed(2)}`;
    }
  }
}
</script>
